import { forAllCallback } from '../../../../kwp/scripts/utils/helpers';
var handler = function (items, item, content) {
    var isOpen = item.classList.contains('open');
    items.forEach(function (item) {
        var content = item.querySelector('.accordion-item--content');
        item.classList.remove('open');
        if (content) {
            content.style.height = '0';
        }
    });
    if (!isOpen) {
        item.classList.add('open');
        if (content) {
            content.style.height = "".concat(content.scrollHeight, "px");
        }
    }
};
export default (function () {
    forAllCallback('.content-block.content-block--accordion', function (el) {
        var items = el.querySelectorAll('.accordion-item');
        items.forEach(function (item) {
            var title = item.querySelector('.accordion-item--title');
            var content = item.querySelector('.accordion-item--content');
            if (title) {
                title.addEventListener('click', function () { return handler(items, item, content); });
            }
        });
    });
});
